export default __webpack_public_path__ + "static/media/Heart.c7a7c2fc.svg";